import { Button } from '@indipia/ui-core'
import type { NextAction } from '../../types/scheduleList.types'

// 다음 할 일 칸(D-06) — 버튼 1개(빨강 = primary 채움, 노랑 = secondary). 없거나 실행할 수 없으면 '—'.
// 할일 코드는 화면에 표시하지 않는다(S14-S15 구현설계서 8장).
// 전화 아이콘은 만들지 않는다(확정결정 5·6). 버튼 클릭은 표가 행 펼침으로 취급하지 않는다(ui-core Table 펼침 모드).

export interface ScheduleListNextActionCellProps {
  action: NextAction | null
  /** 이 행선지로 실행할 수 있는지(useScheduleListActions.canRunNextAction). false 면 버튼을 숨긴다 */
  canRun: boolean
  onRun: (action: NextAction) => void
}

export function ScheduleListNextActionCell({ action, canRun, onRun }: ScheduleListNextActionCellProps) {
  if (!action || !canRun) return <span style={{ color: 'var(--shell-hint)' }}>—</span>
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: 'var(--spacing-02)' }}>
      <Button
        variant={action.color === 'RED' ? 'primary' : 'secondary'}
        size="sm"
        className="whitespace-nowrap"
        style={{ minWidth: 0, flexShrink: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}
        onClick={() => onRun(action)}
      >
        {action.buttonLabel}
      </Button>
    </div>
  )
}
